const TIMEZONE_ALIAS_MAP = {
  'Asia/Calcutta': 'Asia/Kolkata',
  'Asia/Rangoon': 'Asia/Yangon',
  'Asia/Kashgar': 'Asia/Urumqi',
  'Asia/Macao': 'Asia/Macau',
  'Asia/Saigon': 'Asia/Ho_Chi_Minh',
  'Asia/Tel_Aviv': 'Asia/Jerusalem',
  'Europe/Kiev': 'Europe/Kyiv',
  'US/Eastern': 'America/New_York',
  'US/Central': 'America/Chicago',
  'US/Mountain': 'America/Denver',
  'US/Pacific': 'America/Los_Angeles'
};

export const normalizeTimeZone = (timeZone) => {
  if (!timeZone || typeof timeZone !== 'string') {
    return 'UTC';
  }
  return TIMEZONE_ALIAS_MAP[timeZone] || timeZone;
};

export const getUserTimeZone = () => normalizeTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
